import _ from 'lodash';

import type { User } from './../zustandStore/slices';

export const isCompanyAdmin = (roles: User['roles']) => !!roles.some(role => role.roleId === 'company_admin');

export const isSupportAdmin = (roles: User['roles']) =>
	!!roles.some(role => role.roleId === 'tradeshift_support_admin');

export const isCompanyOrSupportAdmin = (roles: User['roles']) => isCompanyAdmin(roles) || isSupportAdmin(roles);

export const isTeamAdmin = (roles: User['roles']) => !!roles.some(role => role.roleId === 'team_admin');

export const isManager = (roles: User['roles']) => !!roles.some(role => role.roleId === 'manager');

export const fullName = (user: User) => {
	user = user || {};
	const firstName = user.firstName || '';
	const lastName = user.lastName || '';

	if (!firstName && !lastName) {
		return _.escape(user.email);
	}
	let fullName = firstName + ' ';
	fullName = fullName + lastName;
	return _.escape(fullName);
};
